import { render, staticRenderFns } from "./RequestVersionsList.vue?vue&type=template&id=27460cd3&scoped=true"
import script from "./RequestVersionsList.vue?vue&type=script&lang=ts"
export * from "./RequestVersionsList.vue?vue&type=script&lang=ts"
import style0 from "./RequestVersionsList.vue?vue&type=style&index=0&id=27460cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27460cd3",
  null
  
)

export default component.exports